{"id":"AppStore","prefabs":{"default":{"children":[{"component":"AppStore","options":"options:*"}]}}}